export default function(weight) {
  return {
    type: "SET_WEIGHT",
    weight
  }
}



// WEBPACK FOOTER //
// ./src/actions/setWeight.js